import { render, staticRenderFns } from "./endpoints.vue?vue&type=template&id=4a506db5&"
import script from "./endpoints.vue?vue&type=script&lang=js&"
export * from "./endpoints.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports